<template>
    <div class="platform_box">
      <div class="platform_header">
        <div class="left-header">
            <img style="width: 44px; margin-right: 12px" src="@/assets/img/icon-logo.png" />
            <span class="header-title">辽宁省政府采购协会</span>
        </div>
        <div class="right-header">
            <img style="margin-right: 8px;" src="@/assets/img/欢迎页.png" />
            <span style="color: #1e242a;font-size: 16px">欢迎选择自行采购服务平台</span>
        </div>
      </div>
      <div class="sys_box">
        <div class="sys_left">
          <div class="sys_item">
            <div class="maining">
              <img src="@/assets/img/zicaipingtai.png"  />
            </div>
            <div class="procurement">博思自行采购平台</div>
            <div class="item_content">
              <span>联系人</span>
              <span>刘思聪</span>
            </div>
            <div class="item_content">
              <span>联系电话</span>
              <span>13942449331</span>
            </div>
            <div align="center" >
              <el-button  class="buttonSelf" @click="goBo">点击进入</el-button>
           </div>
          </div>
          <div><el-button class="introduceBtn" @click="lookBoss">博思公采云平台简介</el-button></div>
          <div><el-button class="introduceBtn" @click="handlePoliciesRegulationsEvent('boss')">博思公采云操作手册</el-button></div>
        </div>
        <div class="sys_right">
          <div class="sys_item">
            <div class="maining">
              <img src="@/assets/img/haofeng.png"  />
            </div>
            <div class="procurement">灏丰自行采购平台</div>
            <div class="item_content">
              <span>联系人</span>
              <span>李营</span>
            </div>
            <div class="item_content">
              <span>联系电话</span>
              <span>18640270521</span>
            </div>
            <div align="center" >
              <el-button  class="buttonSelf" @click="goHao">点击进入</el-button>
           </div>
          </div>
          <div><el-button class="introduceBtn" @click="lookhaofeng">灏丰自采平台简介</el-button></div>
          <div><el-button class="introduceBtn" @click="handlePoliciesRegulationsEvent('haofeng')">灏丰自采操作手册</el-button></div>
        </div>
      </div>

      <el-dialog :show-close="false" :visible.sync="dialog_img_haofeng" width="1080px">
        <el-carousel indicator-position="none" height="585px">
          <el-carousel-item v-for="(banner, index) in banner2" :key="index">
            <img :src="banner" style="height:620px"/>
          </el-carousel-item>
        </el-carousel>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" plain size="small" @click="dialog_img_haofeng = false">关  闭</el-button>
        </div>
      </el-dialog>
    </div>
</template>
<script>
  import img11 from '@/assets/img/haofeng/1.png';
  import img12 from '@/assets/img/haofeng/2.png';
  import img13 from '@/assets/img/haofeng/3.png';
  import img14 from '@/assets/img/haofeng/4.png';

  export default ({
    data() {
      return {
        dialog_img_boss: false,
        dialog_img_haofeng: false,
        banner2: [img11, img12, img13, img14],

      }
    },
    methods: {
      goHao() {
        // window.open("http://120.46.175.97/")
        // window.open("http://36.131.215.40:9011/")
        window.open("http://121.37.101.193:9011/")
      },
      goBo() {
        window.open("http://gcycloud.cn/freecms/site/gcy/index.html")
      },
      lookBoss() {
        window.open('http://39.98.121.212/gpassoc-file/news/gcynotice.pdf ')
      },
      lookhaofeng() {
        this.dialog_img_haofeng = true;
      },
      handlePoliciesRegulationsEvent(val) {
        if (val == 'boss') {
          window.open(`/#/detail/80aab09c-6738-49c7-8eed-52525ee453e4`);
        }
        if (val == 'haofeng') {
          window.open(`/#/detail/f97ccc7a-efed-49d2-8e1f-7166c628d003`);

        }
      }
    }
  })
</script>

<style lang="scss">
  html, body, #app {
    background: #F8F8F8;

  }

  .platform_box {
    height: 100%;

    .platform_header {
      height: 100px;
      display: flex;
      align-items: center;
      background: #F8F8F8;
      justify-content: space-between;
      .header-title {
        font-size: 24px;
        font-weight: 700;
        color: #006117;
      }
      .left-header, .right-header {
        display: flex;
        align-items: center;
      }
    }

    @media screen and (max-width: 1500px){
      .platform_header {
        padding: 0 50px;
      }
    }
    .el-carousel__item {
      text-align: center;
    }
    .btn {
      width: 200px;
      height: 40px;
      background: #006117;
      border-radius: 8px;
      color: #fff;
      margin-top: 32px;
    }
  }

  .sys_box {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    background: url(../assets/img/platform_bg.png) no-repeat;
    height: auto;
    .sys_item {
      width: 480px;
      height: 540px;
      background: #ffffff;
      border-radius: 16px;
      margin-bottom: 48px;
      &:hover {
        box-shadow: 0px 10px 40px 0px rgba(21,24,26,0.06);
      }
    }
    .maining {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
    }
    .procurement{
      font-size: 24px;
      font-weight: 700;
      text-align: center;
      margin-bottom: 30px;
      margin-top: 20px;
    }
    .item_content {
      height: 40px;
      border-bottom: 1px solid #e7edf0;
      margin: 20px 80px;
      font-size: 16px;
      font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
      font-weight: 400;
      color: #666666;
      display: flex;
      justify-content: space-between;
    }
    .buttonSelf {
      width: 320px;
      height: 40px;
      background: #006117;
      border-radius: 8px;
      color: #ffffff;
      margin-top: 28px;
    }
    .sys_left {
      margin-right: 80px;
    }
    .introduceBtn {
      width: 480px;
      height: 40px;
      background: #ffffff;
      border-radius: 8px;
      color: #006117;
      font-size: 16px;
      margin-bottom: 24px;
      border: none
    }
  }
</style>
